import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import { BoxShadow } from '../../../../shared/GlobalStyles';

const Description = styled('div')`
  font-size: 20px;
  text-align: center;
`;

const Header = styled('div')`
  color: #444444;
  font-size: 22px;
`;

const HeaderContainer = styled('div')`
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
`;

const ModalContainer = styled('div')`
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: ${BoxShadow};
  font-family: 'Nunito Sans';
  left: 50%;
  padding: 24px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  z-index: 1;
`;

const InvalidTokenModal = ({ noData }) => (
  <ModalContainer>
    <HeaderContainer>
      <Header>{noData ? 'No Data Found' : 'Invalid Token'}</Header>
    </HeaderContainer>
    <Description>
      {noData
        ? 'The shared dashboard has no associated data. Please check the link you were given and try again'
        : 'This token is either expired or invalid. Please check the link you were given and try again.'}
    </Description>
  </ModalContainer>
);

InvalidTokenModal.propTypes = {
  noData: PropTypes.bool,
};

InvalidTokenModal.defaultProps = {
  noData: false,
};

export default InvalidTokenModal;
